/* Nova theme JS v5 — Premium DTC */
(function(){
  'use strict';

  document.documentElement.classList.remove('no-js');

  // ============ SCROLL REVEAL (IntersectionObserver) ============
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('.reveal, .reveal-stagger').forEach(el => revealObserver.observe(el));
  } else {
    document.querySelectorAll('.reveal, .reveal-stagger').forEach(el => el.classList.add('is-visible'));
  }

  // ============ ANIMATED COUNTERS ============
  function animateCounter(el) {
    const target = parseFloat(el.dataset.counterTarget || el.textContent.replace(/[^\d.-]/g, '')) || 0;
    const duration = parseInt(el.dataset.counterDuration || 1800, 10);
    const prefix = el.dataset.counterPrefix || '';
    const suffix = el.dataset.counterSuffix || '';
    const decimals = parseInt(el.dataset.counterDecimals || 0, 10);
    const startTime = performance.now();

    function step(now) {
      const elapsed = now - startTime;
      const t = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      const val = target * eased;
      el.textContent = prefix + val.toFixed(decimals) + suffix;
      if (t < 1) requestAnimationFrame(step);
      else el.textContent = prefix + target.toFixed(decimals) + suffix;
    }
    requestAnimationFrame(step);
  }
  if ('IntersectionObserver' in window) {
    const counterObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          counterObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('[data-counter]').forEach(el => counterObserver.observe(el));
  }

  // ============ HEADER scroll state ============
  const siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    const onScroll = () => {
      siteHeader.classList.toggle('is-scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ============ MOBILE MENU ============
  const menuToggle = document.querySelector('.menu-toggle');
  const headerNav = document.querySelector('.header-nav');
  if (menuToggle && headerNav) {
    menuToggle.addEventListener('click', () => headerNav.classList.toggle('is-open'));
  }

  // ============ CART DRAWER ============
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');
  const cartTriggers = document.querySelectorAll('[data-cart-trigger]');
  const cartCloseBtn = document.querySelector('.cart-drawer__close');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  cartTriggers.forEach(t => t.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function refreshCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => { renderCart(cart); updateCartCount(cart.item_count); })
      .catch(() => {});
  }

  // Ücretsiz kargo eşiği (kuruş cinsinden). 20000 = 200 TL.
  const FREE_SHIP_THRESHOLD = 20000;
  function updateFreeShip(total, count) {
    const box = document.querySelector('[data-freeship]');
    if (!box) return;
    if (!count) { box.hidden = true; box.innerHTML = ''; return; }
    box.hidden = false;
    const remaining = Math.max(0, FREE_SHIP_THRESHOLD - total);
    const pct = Math.min(100, Math.round((total / FREE_SHIP_THRESHOLD) * 100));
    if (remaining <= 0) {
      box.innerHTML = '<div class="cart-freeship is-complete">'
        + '<div class="cart-freeship__msg"><svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg>Tebrikler! Siparişin ÜCRETSİZ KARGO ile gelecek 🎉</div>'
        + '<div class="cart-freeship__bar"><div class="cart-freeship__fill" style="width:100%"></div></div></div>';
    } else {
      box.innerHTML = '<div class="cart-freeship">'
        + '<div class="cart-freeship__msg">Ücretsiz kargoya <strong style="margin:0 .25rem">' + formatMoney(remaining) + '</strong> kaldı!</div>'
        + '<div class="cart-freeship__bar"><div class="cart-freeship__fill" style="width:' + pct + '%"></div></div></div>';
    }
  }

  function renderCart(cart) {
    updateFreeShip(cart.item_count === 0 ? 0 : cart.total_price, cart.item_count);
    const body = document.querySelector('.cart-drawer__body');
    const totalEl = document.querySelector('.cart-drawer__total-amount');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><p>Sepetiniz boş.</p><a href="/collections/all" class="btn btn--outline">Alışverişe Devam Et</a></div>';
      if (totalEl) totalEl.textContent = formatMoney(0);
      return;
    }
    body.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-line="${item.key}">
        <div class="cart-item__image"><img src="${item.image || ''}" alt="${item.product_title}"></div>
        <div class="cart-item__info">
          <h4 class="cart-item__title">${item.product_title}</h4>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
          <div style="display:flex;align-items:center;gap:.5rem;margin-top:.5rem;">
            <button class="cart-item__qty-btn" data-action="dec" data-key="${item.key}" style="width:28px;height:28px;border:1px solid #ddd;background:#fff;border-radius:50%;">−</button>
            <span style="font-weight:700;min-width:1.5rem;text-align:center;">${item.quantity}</span>
            <button class="cart-item__qty-btn" data-action="inc" data-key="${item.key}" style="width:28px;height:28px;border:1px solid #ddd;background:#fff;border-radius:50%;">+</button>
            <button class="cart-item__remove" data-key="${item.key}" style="margin-left:auto;background:none;border:0;color:#999;font-size:.85rem;text-decoration:underline;">Kaldır</button>
          </div>
        </div>
      </div>
    `).join('');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    body.querySelectorAll('.cart-item__qty-btn').forEach(b => {
      b.addEventListener('click', () => {
        const key = b.dataset.key, action = b.dataset.action;
        const item = cart.items.find(i => i.key === key);
        if (!item) return;
        const newQty = action === 'inc' ? item.quantity + 1 : Math.max(0, item.quantity - 1);
        changeCartLine(key, newQty);
      });
    });
    body.querySelectorAll('.cart-item__remove').forEach(b => b.addEventListener('click', () => changeCartLine(b.dataset.key, 0)));
  }

  function changeCartLine(key, qty) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(r => r.json()).then(cart => { renderCart(cart); updateCartCount(cart.item_count); });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  }

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return amount.replace('.', ',') + ' TL';
  }

  // ============ PRODUCT PAGE ============
  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {

    // Gallery
    document.querySelectorAll('[data-thumb]').forEach(thumb => {
      thumb.addEventListener('click', () => {
        document.querySelector('[data-main-img]').src = thumb.dataset.thumb;
        document.querySelectorAll('[data-thumb]').forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    // ============================================================
    // VARIANT SELECTION — pozisyon-bazlı, isolate edilmiş state
    // ============================================================
    // Her option (Size, Color, vs.) kendi name="option-N" grubunda.
    // Renk değişimi → sadece o pozisyondaki seçim değişir; diğerleri korunur.
    // ============================================================

    const variantGroups = productForm.parentElement.querySelectorAll('[data-variant-group]') || [];
    const allVariantInputs = productForm.parentElement.querySelectorAll('.product__variant-input');
    const variantIdInput = productForm.querySelector('input[name="id"]');
    const variantsData = window.productVariants || [];
    const priceEl = document.querySelector('[data-product-price]');
    const comparePriceEl = document.querySelector('[data-product-compare-price]');
    const atcButton = productForm.querySelector('[data-atc]');
    const atcPriceEl = productForm.querySelector('[data-atc-price]');

    // Tek adet bundle fiyatı için kart referansları (bundle modülünde dolduruluyor)
    let activeBundle = { qty: 1, finalCents: null, compareCents: null };

    function getSelectedOptions() {
      // Her option grubu için pozisyona göre seçili değeri topla.
      // Eğer bir grupta hiç seçim yoksa null koy — variant eşleştirmesi yapma.
      const selected = [];
      variantGroups.forEach(group => {
        const pos = parseInt(group.dataset.optionPosition, 10);
        const checked = group.querySelector('.product__variant-input:checked');
        selected[pos - 1] = checked ? checked.value : null;
      });
      return selected;
    }

    function findMatchingVariant(selected) {
      if (variantsData.length === 1) return variantsData[0];
      // Tüm pozisyonların eşleşmesi gerekir. null pozisyon varsa eşleşme yok.
      return variantsData.find(v => {
        if (!v.options || v.options.length !== selected.length) return false;
        return selected.every((val, idx) => val !== null && String(v.options[idx]) === String(val));
      }) || null;
    }

    function updateSelectedLabels() {
      // Her option başlığının yanındaki "seçili değer" text'ini güncelle
      variantGroups.forEach(group => {
        const checked = group.querySelector('.product__variant-input:checked');
        const labelEl = group.querySelector('[data-selected-value]');
        if (labelEl) labelEl.textContent = checked ? checked.value : '';
      });
    }

    function updateSoldOutPills() {
      // Her pill için: bu değer + diğer seçili değerler kombinasyonu var mı?
      const selected = getSelectedOptions();
      allVariantInputs.forEach(input => {
        const pos = parseInt(input.dataset.optionPosition, 10);
        const val = input.value;
        // Bu pill'i seçtiğimizi varsay, diğer pozisyonlar sabit kalsın
        const probe = selected.slice();
        probe[pos - 1] = val;
        const exists = variantsData.some(v => {
          if (!v.options || v.options.length !== probe.length) return false;
          return probe.every((pv, idx) => pv === null || String(v.options[idx]) === String(pv));
        });
        const available = variantsData.some(v => {
          if (!v.options || v.options.length !== probe.length) return false;
          return probe.every((pv, idx) => pv === null || String(v.options[idx]) === String(pv)) && v.available;
        });
        const pill = input.nextElementSibling;
        if (!pill) return;
        pill.classList.toggle('is-unavailable', exists && !available);
        pill.classList.toggle('is-nonexistent', !exists);
      });
    }

    function currentVariantPriceCents() {
      const selected = getSelectedOptions();
      const v = findMatchingVariant(selected);
      return v ? v.price : (variantsData[0] && variantsData[0].price) || 0;
    }

    function formatPricing(finalCents, compareCents) {
      if (priceEl) priceEl.textContent = formatMoney(finalCents);
      if (comparePriceEl) {
        if (compareCents && compareCents > finalCents) {
          comparePriceEl.textContent = formatMoney(compareCents);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (atcPriceEl) atcPriceEl.textContent = formatMoney(finalCents);
    }

    function updateVariant() {
      const selected = getSelectedOptions();
      const v = findMatchingVariant(selected);

      updateSelectedLabels();
      updateSoldOutPills();

      if (variantIdInput && v) variantIdInput.value = v.id;

      // Fiyat: bundle aktifse bundle'ın fiyatı görünür; aksi halde variant × qty
      const qty = parseInt(document.querySelector('[data-qty]')?.value || 1, 10);
      let finalCents, compareCents;
      if (activeBundle.finalCents) {
        finalCents = activeBundle.finalCents;
        compareCents = activeBundle.compareCents;
      } else if (v) {
        finalCents = v.price * qty;
        compareCents = (v.compare_at_price && v.compare_at_price > v.price)
          ? v.compare_at_price * qty
          : null;
      } else {
        // Eşleşme yoksa fallback: ilk variant
        const fallback = variantsData[0];
        if (!fallback) return;
        finalCents = fallback.price * qty;
        compareCents = null;
      }
      formatPricing(finalCents, compareCents);

      if (atcButton) {
        const isAvailable = v ? v.available : false;
        atcButton.disabled = !isAvailable;
        const textEl = atcButton.querySelector('.atc-text');
        if (textEl) {
          textEl.textContent = isAvailable
            ? (atcButton.dataset.atcText || 'SEPETE EKLE')
            : (v ? 'TÜKENDİ' : 'BU KOMBİNASYON YOK');
        }
      }
    }

    // Her radio input'a sadece tıklama → o pozisyonun seçimini günceller.
    // Aynı `name`'i paylaşan radio'lar otomatik birbirini iptal eder
    // ama FARKLI `name`'ler birbirine müdahale etmez.
    allVariantInputs.forEach(i => i.addEventListener('change', updateVariant));

    // Quantity
    const qtyInput = productForm.querySelector('[data-qty]');
    productForm.querySelectorAll('[data-qty-btn]').forEach(btn => {
      btn.addEventListener('click', () => {
        const action = btn.dataset.qtyBtn;
        let v = parseInt(qtyInput.value, 10) || 1;
        if (action === 'inc') v++; else if (action === 'dec') v = Math.max(1, v - 1);
        qtyInput.value = v;
        updateVariant();
      });
    });
    if (qtyInput) qtyInput.addEventListener('input', updateVariant);

    // ============================================================
    // BUNDLE selector — sadece qty + fiyat etkisi, variant seçimine DOKUNMAZ
    // ============================================================
    document.querySelectorAll('[data-bundle]').forEach(card => {
      card.addEventListener('click', () => {
        document.querySelectorAll('[data-bundle]').forEach(c => {
          c.classList.remove('is-active');
          c.setAttribute('aria-pressed', 'false');
        });
        card.classList.add('is-active');
        card.setAttribute('aria-pressed', 'true');

        const qty = parseInt(card.dataset.bundle, 10) || 1;
        const finalCents = parseInt(card.dataset.bundleFinal, 10) || null;
        const compareCents = parseInt(card.dataset.bundleCompare, 10) || null;

        activeBundle = { qty, finalCents, compareCents };

        if (qtyInput) qtyInput.value = qty;
        updateVariant();
      });
    });

    // İlk aktif bundle kartının fiyatını yakalayıp activeBundle'a koy
    const initialActiveBundle = document.querySelector('[data-bundle].is-active');
    if (initialActiveBundle) {
      activeBundle = {
        qty: parseInt(initialActiveBundle.dataset.bundle, 10) || 1,
        finalCents: parseInt(initialActiveBundle.dataset.bundleFinal, 10) || null,
        compareCents: parseInt(initialActiveBundle.dataset.bundleCompare, 10) || null
      };
      if (qtyInput) qtyInput.value = activeBundle.qty;
    }

    updateVariant();

    // ATC submit
    productForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const formData = new FormData(productForm);
      atcButton.disabled = true;
      const textEl = atcButton.querySelector('.atc-text');
      const originalText = textEl ? textEl.textContent : atcButton.textContent;
      if (textEl) textEl.textContent = 'EKLENİYOR...';
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(r => r.json())
        .then(() => {
          if (textEl) textEl.textContent = '✓ SEPETE EKLENDİ';
          setTimeout(() => { atcButton.disabled = false; if (textEl) textEl.textContent = originalText; }, 1500);
          openCart();
        })
        .catch(() => { atcButton.disabled = false; if (textEl) textEl.textContent = originalText; alert('Hata. Tekrar deneyin.'); });
    });
  }

  // ============ STICKY ATC ============
  const stickyAtc = document.querySelector('.sticky-atc');
  if (stickyAtc && productForm) {
    document.body.classList.add('has-sticky-atc');
    const atcButton = productForm.querySelector('[data-atc]');
    const stickyBtn = stickyAtc.querySelector('.sticky-atc__btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', (e) => {
        e.preventDefault();
        atcButton?.click();
        atcButton?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    const heroAtc = productForm.querySelector('[data-atc]');
    if (heroAtc && 'IntersectionObserver' in window) {
      const atcObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      atcObserver.observe(heroAtc);
    }
  }

  // ============ CONTENT TABS ============
  document.querySelectorAll('[data-tabs]').forEach(container => {
    const buttons = container.querySelectorAll('[data-tab-btn]');
    const panes = container.querySelectorAll('[data-tab-pane]');
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.classList.remove('is-active'));
        panes.forEach(p => p.classList.remove('is-active'));
        btn.classList.add('is-active');
        const target = container.querySelector(`[data-tab-pane="${btn.dataset.tabBtn}"]`);
        if (target) target.classList.add('is-active');
      });
    });
  });

  // ============ VIDEO POSTER PLAY ============
  document.querySelectorAll('[data-video-poster]').forEach(poster => {
    poster.addEventListener('click', () => {
      const videoId = poster.dataset.videoId;
      const provider = poster.dataset.videoProvider || 'youtube';
      let src = '';
      if (provider === 'youtube') src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
      else if (provider === 'vimeo') src = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.allow = 'autoplay; encrypted-media';
      iframe.allowFullscreen = true;
      poster.parentNode.appendChild(iframe);
      poster.style.display = 'none';
    });
  });

  // ============ Initial cart count ============
  fetch('/cart.js').then(r => r.json()).then(cart => updateCartCount(cart.item_count)).catch(() => {});

})();
